<template>
    <v-text-field
        ref="keyTime"
        v-model="keyTime"
        :label="label"
        outlined dense class="mx-4"
        :hint="$t('common.format-time')" 
        persistent-hint
        @keypress="restrictFormat"
        :rules="rulesTime"
        @input="saveTime"
    ></v-text-field>
</template>

<script>
import _ from "lodash";

export default {
    props: { 
        time: { type: Object, default: () => {}}, 
        label: String
    },
    data() {
        return {
          timeLocal: null  
        };
    },
    computed: {
        rulesTime() {
            return [
                (v) => this.$inputRules({ value: (v || '') }, 'filled') || this.$t('common.format-time-required'),
                (v) => {
                    return this.$inputRules({ value: v }, 'nullable') || this.$inputRules({ value: v }, 'time') || this.$t('common.format-time-invalid');
                }
            ];
        },
        keyTime: {
            get() {
                return this.time.keyTime;
            },
            set(val) {
                this.saveTime(val);
            }
        }
    },
    methods: {
        saveTime(val) {
            //if(this.$refs.keyTime.validate()) {
            let item = this.time;
            item.keyTime = val;
            this.$emit('updateField', { item });
            //}
        },
        cancelTime() {
            this.menu = false;
        },
        updateField: _.debounce(function (value) {
      
            if ((value || "").length == 0 && value != 0) return false;
                
            if(!this.validateTime(value)) return false;

            this.timeLocal = value;
        }, 500),
        validateTime(time) {
            const timeReg = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
            return timeReg.test(time);
        },
        restrictFormat($event) {
            if((this.time.keyTime || "").length == 0 && /[0-2]/.test(String.fromCharCode($event.charCode))) { 
                $event.preventDefault();
                this.keyTime = $event.key;
                //return true; 
            } else if(
                (this.time.keyTime || "").length == 1 && (
                (parseInt(this.time.keyTime) == 2 && /[0-3]/.test(String.fromCharCode($event.charCode))) || 
                (parseInt(this.time.keyTime) < 2 && /\d/.test(String.fromCharCode($event.charCode)))
            )) {
                $event.preventDefault();
                this.keyTime += $event.key + ':';
                //return true;
            } else if(((this.time.keyTime || "").length == 2 || (this.time.keyTime || "").length == 5) && $event.key == ':') {
                return true;
            } else if(
                ((this.time.keyTime || "").length == 3 || (this.time.keyTime || "").length == 6) && 
                /[0-5]/.test(String.fromCharCode($event.charCode))
            ) { 
                $event.preventDefault();
                this.keyTime += $event.key;
                //return true; 
            } else if(
                ((this.time.keyTime || "").length == 4 || (this.time.keyTime || "").length == 7) && 
                /\d/.test(String.fromCharCode($event.charCode))
            ) {
                if((this.time.keyTime || "").length == 4) {
                    $event.preventDefault();
                    this.keyTime += $event.key + ':';
                } else {
                    return true;
                }
            } else {
                $event.preventDefault();
            }
        },
    },
    watch: {
        time() {
            this.timeLocal = this.time.keyTime;
        }
    }
};
</script>
